import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { FuseNavigation } from '@fuse/types';

import { saleNavigation } from './navigation';
import { locale as vn } from './i18n/vn';
import { locale as english } from './i18n/en';

import { SidebarDetailComponent } from '@appshared';
import { ReconciledDetailTicketService } from './data-list/services';
import { AclService } from '@aes/acl/acl.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SaleNavigationHelper } from './sale-navigation-helper.provider';
import { SaleSseService } from './services/sale-sse.service';
import { AppService } from 'app/services';

@Component({
  selector: 'app-sale',
  templateUrl: './sale.component.html',
  styleUrls: ['./sale.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SaleComponent implements OnInit, AfterViewInit, OnDestroy {
  saleNavigation: FuseNavigation[];
  detailSidebars: SidebarDetailComponent[] = [];

  private readonly destroy$ = new Subject<void>();

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _fuseNavigationService: FuseNavigationService,
    private _reconciledDetailTicketService: ReconciledDetailTicketService,
    private _saleNavigation: SaleNavigationHelper,
    private _aclService: AclService,
    private _saleSseService: SaleSseService,
    private _appService: AppService
  ) {
    this._fuseTranslationLoaderService.loadTranslations(english, vn);
  }

  ngAfterViewInit(): void {
    this._reconciledDetailTicketService.renderView();
  }

  ngOnInit(): void {
    // Get default navigation
    this.saleNavigation = saleNavigation;
    this.saleNavigation = this._appService.translateLeftSideBar(this.saleNavigation);
    
    // Register the navigation to the service
    this._fuseNavigationService.register('sale', this.saleNavigation);

    // Set the main navigation as our current navigation
    this._fuseNavigationService.setCurrentNavigation('sale');

    // Get notified each time getAccountAbilityState state changes.
    this._aclService
      .getAccountAbilityState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(ability => this.listenTicketSseEvent());

    this._saleSseService
      .getTicketSseInfoState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(ticketSseEmitter => {
        this._saleNavigation.updateBadge(ticketSseEmitter);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this._saleSseService.destroy();
    this._reconciledDetailTicketService.destroyView();
  }

  private listenTicketSseEvent(): void {
    this._saleSseService.listen();
  }
}
